import React, { useState } from 'react';
import { featuredTestimonials, moreTestimonials, type Testimonial } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Stars } from './Stars';
import { Accordion } from './Accordion';
import { CtaButton } from './CtaButton';
import { ReviewForm } from './ReviewForm';
const accents = ['bg-blush', 'bg-sky', 'bg-sage', 'bg-lilac'];
const initials = (name: string) => name.replace('.', '').split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
function TestimonialCard({
  testimonial,
  accent
}: {
  testimonial: Testimonial;
  accent: string;
}) {
  return <article className="flex h-full overflow-hidden rounded-2xl border border-line bg-white" data-id="element-140" data-mp="1427xpsb5u6ay">
      <span aria-hidden="true" className={`w-1.5 shrink-0 ${accent}`} data-id="element-141" data-mp="181zznm61te7c" />
      <div className="flex flex-1 flex-col px-6 py-6" data-id="element-142" data-mp="2yfgxgsdwmdg0">
        <div className="flex items-center gap-3" data-id="element-143" data-mp="2yfpemwh284x0">
          <span aria-hidden="true" className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-sans text-[14px] font-bold text-ink ${accent}`} data-id="element-144" data-mp="32haw6v4jh7dj">
            {initials(testimonial.name)}
          </span>
          <div className="min-w-0" data-id="element-145" data-mp="2q1gbay6gff5j">
            <p className="font-sans text-[15px] font-bold text-ink" data-id="element-146" data-mp="2q0eyop9siklp">
              {testimonial.name}
            </p>
            <p className="font-sans text-[13px] text-muted" data-id="element-147" data-mp="2zsavlx0544oc">
              {testimonial.location}
            </p>
          </div>
          <Stars className="ml-auto" data-id="element-148" data-mp="2c1x2e35tjzs6" />
        </div>
        <blockquote className="mt-5 font-sans text-[16px] italic leading-relaxed text-ink-soft" data-id="element-149" data-mp="2c4t13tphqsho">
          “{testimonial.text}”
        </blockquote>
        <p className="mt-auto pt-5 font-sans text-[13px] text-muted" data-id="element-150" data-mp="2m163dfz3qeo1">
          {testimonial.date}
        </p>
      </div>
    </article>;
}
export function TestimonialsSection() {
  const [showAll, setShowAll] = useState(false);
  return <section className="bg-white px-5 py-10 sm:px-8 lg:py-14" data-id="element-151" data-mp="1942adllxwch">
      <div className="mx-auto w-full max-w-content" data-id="element-152" data-mp="3shrloo0af9he">
        <SectionTitle className="uppercase" data-id="element-153" data-mp="3sj2rsuh7gtbo">
          LOS DOCENTES NOS RECOMIENDAN
        </SectionTitle>
        <div className="mt-6 grid gap-4 lg:grid-cols-2" data-id="element-154" data-mp="3h4vnuo2ihsj">
          {featuredTestimonials.map((testimonial, i) => <TestimonialCard key={testimonial.name} testimonial={testimonial} accent={accents[i % accents.length]} data-id="element-155" data-mp="dcyjwbb5fzq5" data-mpi={i} />)}
        </div>
        {!showAll ? <div className="mx-auto mt-8 max-w-[460px]" data-id="element-156" data-mp="ib03cxchm125">
            <CtaButton variant="outline" label={`Ver más reseñas (${moreTestimonials.length} historias más)`} sublabel="Conocé cómo fue la experiencia de otras personas" onClick={() => setShowAll(true)} data-id="element-157" data-mp="3gtou72drkyxn" />
          </div> : <div className="mt-8 space-y-3" data-id="element-158" data-mp="3qs4kj34yw463">
            {moreTestimonials.map((testimonial, i) => <Accordion key={testimonial.name} id={`review-${i + 1}`} defaultOpen={i === 0} openClassName="bg-cream" header={<span className="flex items-center gap-3" data-id="element-160" data-mp="2y3fgav8m7iq4">
                    <span aria-hidden="true" className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full font-sans text-[13px] font-bold text-ink ${accents[i % accents.length]}`} data-id="element-161" data-mp="2y2xelj36ocat">
                      {initials(testimonial.name)}
                    </span>
                    <span className="min-w-0" data-id="element-162" data-mp="1g6vn3nxe67jb">
                      <span className="block font-sans text-[15px] font-bold text-ink" data-id="element-163" data-mp="1g3ptpwhqcjhs">
                        {testimonial.name}
                      </span>
                      <span className="block font-sans text-[13px] text-muted" data-id="element-164" data-mp="166uzvqwej79u">
                        {testimonial.location}
                      </span>
                    </span>
                  </span>} data-id="element-159" data-mp="3vikyqpgm3tti" data-mpi={i}>
                <blockquote className="font-sans text-[16px] italic leading-relaxed text-ink-soft" data-id="element-165" data-mp="wg0fks2puhr1">
                  “{testimonial.text}”
                </blockquote>
                <p className="mt-4 font-sans text-[13px] text-muted" data-id="element-166" data-mp="nhoflzfym7lx">
                  {testimonial.date}
                </p>
              </Accordion>)}
          </div>}
        <div className="mt-8" data-id="element-167" data-mp="dipdz0tm3c8f">
          <ReviewForm data-id="element-168" data-mp="difnlc4nn327" />
        </div>
      </div>
    </section>;
}